module.exports = __webpack_public_path__ + "img/technology-start.e26f3aaa.jpg";